// Import all theme scripts from scripts/index.js
import * as scripts from "./scripts";

// Import AOS and initialize
import AOS from "aos";
AOS.init();

// Import and initialize smoothscroll polyfill
// import smoothscroll from "smoothscroll-polyfill";
// smoothscroll.polyfill();

// Example of calling functions from your imported scripts
// If you need to specifically initialize headerHeightScroll or other functions:
// scripts.headerHeightScroll();

// If using jQuery functions, ensure jQuery is available
// $(scripts.lightboxEnable);
// $(scripts.responsive.widthChecker);
// $(scripts.responsive.elementsToggle);
// $(window).resize(scripts.responsive.widthChecker);

// Example of binding header scroll behavior
// $(document).on("scroll", scripts.headerHeightScroll);
